export default {
  passport: {
    title: 'Паспорт',
    editComponent: 'DocumentPassportEdit',
    viewComponent: 'DocumentPassportView',
    tabs: { title: 'Паспорт', scansTittle: 'Сканы паспорта' }
  },
  driving_licence: {
    title: 'Водительское удостоверение',
    editComponent: 'DocumentDrivingLicenceEdit',
    viewComponent: 'DocumentDrivingLicenceView',
    tabs: { title: 'Водительское удостоверение', scansTittle: 'Сканы в/у' }
  }
}
